import React from 'react';
import { ChevronUp, ChevronDown, ArrowDownToLine, Rows3, Rows4 } from 'lucide-react';
import { fmtMailDate } from './mailUtils';

const Nb = ({ onClick, disabled, title, children, testid }) => (
  <button onClick={onClick} disabled={disabled} title={title} data-testid={testid} className="p-1 rounded-md text-slate-600 hover:bg-white hover:text-slate-900 disabled:opacity-30">{children}</button>
);

/** Sticky strip so you never lose your place in a long conversation: "3 of 12", older/newer, jump to newest. */
export const ThreadNav = ({ messages, currentIndex, onGo, onExpandAll, onCollapseAll, allOpen }) => {
  const n = messages.length;
  if (n < 2) return null;
  const newest = n - 1;
  const cur = currentIndex >= 0 ? currentIndex : newest;
  const atNewest = cur === newest;
  return (
    <div className="sticky top-0 z-10 mx-4 mt-2 rounded-xl border border-slate-200 bg-white/90 backdrop-blur px-2 py-1 flex items-center gap-1 text-xs shadow-sm" data-testid="mail-thread-nav">
      <span className="font-bold text-slate-900 tabular-nums px-1" data-testid="mail-thread-nav-pos">{cur + 1} of {n}</span>
      <span className="text-slate-500 truncate hidden sm:inline">· {fmtMailDate(messages[cur]?.date, true)} · {messages[cur]?.mine ? 'me' : (messages[cur]?.from?.name || messages[cur]?.from?.email)}</span>
      <div className="ml-auto flex items-center gap-0.5">
        <Nb onClick={() => onGo(cur - 1)} disabled={cur <= 0} title="Older message (p)" testid="mail-thread-nav-prev"><ChevronUp className="w-4 h-4" /></Nb>
        <Nb onClick={() => onGo(cur + 1)} disabled={atNewest} title="Newer message (n)" testid="mail-thread-nav-next"><ChevronDown className="w-4 h-4" /></Nb>
        <button onClick={() => onGo(newest)} className={`ml-1 px-2 py-1 rounded-md font-semibold flex items-center gap-1 ${atNewest ? 'text-emerald-700 bg-emerald-50' : 'bg-sky-600 text-white hover:bg-sky-500'}`} title="Jump to the newest message (End)" data-testid="mail-thread-nav-newest">
          <ArrowDownToLine className="w-3.5 h-3.5" />{atNewest ? 'Newest' : 'Jump to newest'}
        </button>
        <Nb onClick={allOpen ? onCollapseAll : onExpandAll} title={allOpen ? 'Collapse all' : 'Expand all'} testid="mail-thread-nav-expand">{allOpen ? <Rows4 className="w-4 h-4" /> : <Rows3 className="w-4 h-4" />}</Nb>
      </div>
    </div>
  );
};
